export default __webpack_public_path__ + "static/media/eq-basic.44006760.png";